import classnames from 'classnames';
import React from 'react';

import { IconProps } from 'reactComponents/icons/utilities/iconUtils';

import css from '../defaultIconStyles.css';

export const InfraIcon = ({
    width = 16,
    height = 16,
    className,
    ...rest
}: IconProps) => {
    return (
        <svg
            fillRule="evenodd"
            viewBox="0 0 16 16"
            width={width}
            height={height}
            xmlns="http://www.w3.org/2000/svg"
            className={classnames(css.main, className)}
            {...rest}
        >
            <title>Icon infra</title>
            <path
                className={css.colored}
                d="M 6.487 3.58 L 8.28 0.436 C 8.441 0.153 8.736 -0.004 9.038 0 C 9.042 0 9.046 0 9.05 0 L 13.11 0 C 13.443 0 13.732 0.192 13.875 0.472 L 15.885 3.997 C 15.964 4.135 16.001 4.287 16 4.437 C 16.001 4.586 15.964 4.738 15.885 4.877 L 14.104 8 L 15.885 11.123 C 15.964 11.262 16.001 11.414 16 11.563 C 16.001 11.713 15.964 11.865 15.885 12.003 L 13.875 15.528 C 13.732 15.808 13.443 16 13.11 16 L 9.05 16 C 9.046 16 9.042 16 9.038 16 C 8.736 16.004 8.441 15.847 8.28 15.564 L 6.506 12.453 L 2.916 12.453 L 2.904 12.453 L 2.89 12.453 C 2.593 12.453 2.304 12.297 2.146 12.018 L 0.115 8.457 C 0.036 8.318 -0.001 8.166 0 8.017 C -0.001 7.867 0.036 7.716 0.115 7.577 L 2.146 4.016 C 2.304 3.737 2.593 3.581 2.89 3.58 L 2.904 3.58 L 2.916 3.58 L 6.487 3.58 Z  M 12.615 8.873 L 9.52 8.873 L 7.986 11.563 L 9.522 14.257 L 12.612 14.257 L 14.148 11.563 L 12.615 8.873 Z  M 6.478 5.323 L 3.388 5.323 L 1.852 8.017 L 3.388 10.711 L 6.478 10.711 L 8.014 8.017 L 6.478 5.323 Z  M 12.612 1.743 L 9.522 1.743 L 7.986 4.437 L 9.52 7.127 L 12.615 7.127 L 14.148 4.437 L 12.612 1.743 Z"
            />
        </svg>
    );
};

export default InfraIcon;
